import React from 'react';
import ReactDOM from 'react-dom';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import configureStore from './store/configureStore';

// update Chrome Extension

require('dotenv').config();


const store = configureStore();
// let url;
// switch(process.env.REACT_APP_ENV) {
//     case 'local':
//         url = 'http://localhost:4001';
//         break;
//     case 'tech':
//         url = 'http://192.168.0.192:4001';
//         break;
//     default:
//         url = 'http://localhost:4001';
// }
// export const socket = io(url);

ReactDOM.render(
    <Provider store={store}>
        <HashRouter>
            <App />
        </HashRouter>
    </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
